import { useContext } from 'react';
import { DesignSceneContext } from '../DesignSceneContext';

export function useDesignScene() {
    return useContext(DesignSceneContext);
}
